/* PDP gallery video — plays on arrival, not on a press.

   WHY. Dawn ships gallery video behind <deferred-media>: a poster with a play
   triangle, the <video> held in a <template> and not in the DOM until tapped.
   Measured on live 2026-09-22 — Rowan Whitethorn 4 poster buttons / 0 video
   elements, Andarna 2 / 0. And they do not tap: across 26 PDP sessions since the
   batch-2 publish, zero size taps, zero gallery taps, nine clicks in total,
   median dwell 10s. The gallery is swiped, not operated, so a slide that needs a
   press is a slide that does nothing.

   This is the collection-grid pattern (main-collection-product-grid.liquid,
   "reels start when reached") applied to the PDP gallery. Thresholds and the
   rewind rule are deliberately identical so the two surfaces behave the same.

   Only first-party video is handled. YouTube/Vimeo and 3D models keep their
   poster — see the comment in snippets/product-media.liquid for why. */
(function () {
  function init() {
    var vids = document.querySelectorAll('.cnc-pdp-video video');
    if (!vids.length) return;

    /* No observer support: leave the browser's own autoplay attribute to it
       rather than pausing clips we then have no way of restarting. */
    if (!('IntersectionObserver' in window)) return;

    /* Respect the system setting. Someone who has asked for less motion should
       get the first frame as a still, which is what pausing leaves behind. */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Data saver / 2G: a poster is kinder than a clip nobody asked to download. */
    var conn = navigator.connection || {};
    var frugal = !!conn.saveData || (conn.effectiveType && /(^|-)2g$/.test(conn.effectiveType));

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            /* Rewind only when it has genuinely been away, so a swipe wobble
               does not keep restarting the clip under the viewer. */
            if (v.paused && v.currentTime > 0.3) v.currentTime = 0;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { threshold: 0.55 }
    );

    Array.prototype.forEach.call(vids, function (v) {
      /* Belt and braces: Shopify emits these because media_tag was asked for
         autoplay, but a muted+playsinline video is the whole reason mobile will
         play at all, so do not depend on it. */
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');

      v.pause();
      try {
        v.currentTime = 0;
      } catch (e) {
        /* not seekable yet — it will start from 0 anyway */
      }

      if (still || frugal) return; // leave it parked on frame one
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
